<script setup>
import {LayoutGrid, List} from "lucide-vue-next";
import {Button} from "@/components/ui/button/index.js";
import {getViewMode, setViewMode} from "@/services/viewModeService.js";
import {ref} from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

function handleViewModeChange(mode) {
  emit('update:modelValue', mode);
  setViewMode(mode);
}
</script>

<template>
  <div class="flex items-center space-x-2">
    <Button 
      variant="ghost" 
      size="sm" 
      :class="[
        'hover:bg-accent/50',
        modelValue === 'grid' ? 'bg-white border border-accent shadow-sm' : 'text-muted-foreground'
      ]"
      @click="handleViewModeChange('grid')"
    >
      <LayoutGrid class="h-4 w-4" />
    </Button>
    <Button 
      variant="ghost" 
      size="sm" 
      :class="[
        'hover:bg-accent/50',
        modelValue === 'list' ? 'bg-white border border-accent shadow-sm' : 'text-muted-foreground'
      ]"
      @click="handleViewModeChange('list')"
    >
      <List class="h-4 w-4" />
    </Button>
  </div>
</template> 